// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dResult from "../Data.Result/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic$dCoupons$dTypes from "../Restaumatic.Coupons.Types/index.js";
import * as Restaumatic$dForm$dTestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic$dPromotions$dTypes from "../Restaumatic.Promotions.Types/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $GetActivePromotionsError = () => ({tag: "InvalidCoupon"});
const eq = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const eq5 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(Restaumatic$dPromotions$dTypes.eqPromotion.eq))();
const couponCodesIsSymbol = {reflectSymbol: () => "couponCodes"};
const restaurantIdIsSymbol = {reflectSymbol: () => "restaurantId"};
const GetActivePromotionsRequestIsSymbol = {reflectSymbol: () => "GetActivePromotionsRequest"};
const InvalidCouponIsSymbol = {reflectSymbol: () => "InvalidCoupon"};
const genericEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments);
const genericBoundedEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
const codeIsSymbol = {reflectSymbol: () => "code"};
const promotionIdIsSymbol = {reflectSymbol: () => "promotionId"};
const sourceIsSymbol = {reflectSymbol: () => "source"};
const CouponPromotionIsSymbol = {reflectSymbol: () => "CouponPromotion"};
const couponsIsSymbol = {reflectSymbol: () => "coupons"};
const promotionsIsSymbol = {reflectSymbol: () => "promotions"};
const GetActivePromotionsResponseContentIsSymbol = {reflectSymbol: () => "GetActivePromotionsResponseContent"};
const GetActivePromotionsResponseIsSymbol = {reflectSymbol: () => "GetActivePromotionsResponse"};
const GetActivePromotionsRequest = x => x;
const InvalidCoupon = /* #__PURE__ */ $GetActivePromotionsError();
const CouponPromotion = x => x;
const GetActivePromotionsResponseContent = x => x;
const GetActivePromotionsResponse = x => x;
const toFillFormTypeGetActivePr = {fillFormDataType: v => "unknown"};
const toFillFormTypeGetActivePr1 = {fillFormDataType: v => "unknown"};
const toFillFormTypeGetActivePr2 = {fillFormDataType: v => "unknown"};
const toFillFormTypeCouponPromo = {fillFormDataType: v => "unknown"};
const rPCSitesGetActivePromotio = {};
const rPCMethodNameGetActivePro = {rpcMethodName: v => "GetActivePromotionsRequest"};
const newtypeGetActivePromotion = {Coercible0: () => {}};
const newtypeGetActivePromotion1 = {Coercible0: () => {}};
const newtypeGetActivePromotion2 = {Coercible0: () => {}};
const newtypeCouponPromotion_ = {Coercible0: () => {}};
const hasFieldGetActivePromotio = dictHasField => dictHasField;
const hasFieldGetActivePromotio1 = dictHasField => dictHasField;
const hasFieldCouponPromotion = dictHasField => dictHasField;
const eqGetActivePromotionsRequ = {eq: x => y => eq(x.couponCodes)(y.couponCodes) && x.restaurantId === y.restaurantId};
const eqGetActivePromotionsErro = {eq: x => y => true};
const ordGetActivePromotionsErr = {compare: x => y => Data$dOrdering.EQ, Eq0: () => eqGetActivePromotionsErro};
const eqCouponPromotion = {
  eq: x => y => x.code === y.code && x.promotionId === y.promotionId && (() => {
    if (x.source.tag === "Manual") { return y.source.tag === "Manual"; }
    if (x.source.tag === "FirstOrderDiscount") { return y.source.tag === "FirstOrderDiscount"; }
    if (x.source.tag === "Loyalty") { return y.source.tag === "Loyalty"; }
    if (x.source.tag === "Pbx") { return y.source.tag === "Pbx"; }
    if (x.source.tag === "FirstAbsenceReminder") { return y.source.tag === "FirstAbsenceReminder"; }
    if (x.source.tag === "SecondAbsenceReminder") { return y.source.tag === "SecondAbsenceReminder"; }
    if (x.source.tag === "RosPhoneOrder") { return y.source.tag === "RosPhoneOrder"; }
    if (x.source.tag === "RosPortalOrder") { return y.source.tag === "RosPortalOrder"; }
    return false;
  })()
};
const eq6 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(eqCouponPromotion.eq))();
const eqGetActivePromotionsResp = {eq: x => y => eq6(x.coupons)(y.coupons) && eq5(x.promotions)(y.promotions)};
const eq7 = x => y => {
  if (x.tag === "Left") { return y.tag === "Left"; }
  if (x.tag === "Right") {
    if (y.tag === "Right") { return eqGetActivePromotionsResp.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const eqGetActivePromotionsResp1 = {eq: x => y => eq7(x)(y)};
const genericGetActivePromotionsResponseContent = {to: x => x, from: x => x};
const genericGetActivePromotionsResponse = {to: x => x, from: x => x};
const genericGetActivePromotionsRequest = {to: x => x, from: x => x};
const showGetActivePromotionsRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
      return {genericShowArgs: v => ["{ couponCodes: " + $0(v.couponCodes) + ", restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + " " + "}"]};
    })())(GetActivePromotionsRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGetActivePromotionsRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(couponCodesIsSymbol)({unsafeDecode: Unscramble.decodeArray(Unscramble.decodeString)})(Unscramble.decodeRecordCons(restaurantIdIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericGetActivePromotionsError = {to: x => InvalidCoupon, from: x => Data$dGeneric$dRep.NoArguments};
const showGetActivePromotionsError = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(InvalidCouponIsSymbol);
    return x => $0["genericShow'"](Data$dGeneric$dRep.NoArguments);
  })()
};
const unscrambleDecodeGetActivePromotionsError = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericGetActivePromotionsError)({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("InvalidCoupon"), Data$dGeneric$dRep.NoArguments)]
  })(Unscramble$dEnum.defaultEnumOptions)
};
const boundedGetActivePromotion = {top: InvalidCoupon, bottom: InvalidCoupon, Ord0: () => ordGetActivePromotionsErr};
const enumGetActivePromotionsEr = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericGetActivePromotionsError)(genericEnumConstructor),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericGetActivePromotionsError)(genericEnumConstructor),
  Ord0: () => ordGetActivePromotionsErr
};
const boundedEnumGetActivePromo = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumConstructor["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericGetActivePromotionsError)(genericBoundedEnumConstructor),
    fromEnum: x => genericBoundedEnumConstructor["genericFromEnum'"](Data$dGeneric$dRep.NoArguments),
    Bounded0: () => boundedGetActivePromotion,
    Enum1: () => enumGetActivePromotionsEr
  }
))();
const toFillFormTypeGetActivePr3 = {
  fillFormDataType: /* #__PURE__ */ Restaumatic$dForm$dTestHelpers.defaultEnumFillFormDataType(genericGetActivePromotionsError)({
    gdefaultEnumFillFormDataType: v => "\"InvalidCoupon\""
  })
};
const genericCouponPromotion = {to: x => x, from: x => x};
const showCouponPromotion = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ code: " + Data$dShow.showStringImpl(v.code) + ", promotionId: " + Data$dShow.showIntImpl(v.promotionId) + ", source: " + Restaumatic$dCoupons$dTypes.showCouponSource.show(v.source) + " " + "}"
      ]
    })(CouponPromotionIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showGetActivePromotionsResponseContent = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dPromotions$dTypes.showPromotion.show);
      const $1 = Data$dShow.showArrayImpl(showCouponPromotion.show);
      return {genericShowArgs: v => ["{ coupons: " + $1(v.coupons) + ", promotions: " + $0(v.promotions) + " " + "}"]};
    })())(GetActivePromotionsResponseContentIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showGetActivePromotionsResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.tag === "Left") { return "(Left " + showGetActivePromotionsError.show(v._1) + ")"; }
          if (v.tag === "Right") { return "(Right " + showGetActivePromotionsResponseContent.show(v._1) + ")"; }
          $runtime.fail();
        })()
      ]
    })(GetActivePromotionsResponseIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCouponPromotion = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(codeIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(promotionIdIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(sourceIsSymbol)(Restaumatic$dCoupons$dTypes.unscrambleDecodeCouponSource)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeGetActivePromotionsResponseContent = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(couponsIsSymbol)({unsafeDecode: Unscramble.decodeArray(unscrambleDecodeCouponPromotion.unsafeDecode)})(Unscramble.decodeRecordCons(promotionsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dPromotions$dTypes.unscrambleDecodePromotion.unsafeDecode)
    })(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeGetActivePromotionsResponse = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Data$dResult.udecodeResult(unscrambleDecodeGetActivePromotionsError)(unscrambleDecodeGetActivePromotionsResponseContent);
    return x => $0.unsafeDecode(x);
  })()
};
const encodeGetActivePromotionsRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetActivePromotionsRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(GetActivePromotionsRequestIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(restaurantIdIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))(couponCodesIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGetActivePromotionsError = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericGetActivePromotionsError)({encodeEnum: v => v1 => v.constructorTagTransform("InvalidCoupon")})
};
const encodeCouponPromotion = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCouponPromotion)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(CouponPromotionIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(sourceIsSymbol)({
      encodeWithOptions: v => Restaumatic$dCoupons$dTypes.encodeCouponSource.encode
    }))(promotionIdIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(codeIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGetActivePromotionsResponseContent = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetActivePromotionsResponseContent)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(GetActivePromotionsResponseContentIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(promotionsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Restaumatic$dPromotions$dTypes.encodePromotion.encode);
      return {encodeWithOptions: v => encode1};
    })()))(couponsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(encodeCouponPromotion.encode);
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGetActivePromotionsResponse = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetActivePromotionsResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(GetActivePromotionsResponseIsSymbol)({
    encodeArgs: opts => v => Data$dList$dTypes.$List(
      "Cons",
      Foreign$dGeneric$dClass.$Arg(
        "PlainArg",
        (() => {
          if (v.tag === "Left") { return {Left: "InvalidCoupon"}; }
          if (v.tag === "Right") { return {Right: encodeGetActivePromotionsResponseContent.encode(v._1)}; }
          $runtime.fail();
        })()
      ),
      Data$dList$dTypes.Nil
    )
  }))
};
const decodeGetActivePromotionsRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetActivePromotionsRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(GetActivePromotionsRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(restaurantIdIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
  })())(couponCodesIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGetActivePromotionsError = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericGetActivePromotionsError)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(InvalidCouponIsSymbol))
};
const decodeCouponPromotion = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCouponPromotion)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CouponPromotionIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(sourceIsSymbol)({
    decodeWithOptions: v => Restaumatic$dCoupons$dTypes.decodeCouponSource.decode
  })())(promotionIdIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode})())(codeIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.readString})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGetActivePromotionsResponseContent = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetActivePromotionsResponseContent)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(GetActivePromotionsResponseContentIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(promotionsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dPromotions$dTypes.decodePromotion).decode;
    return {decodeWithOptions: v => decode2};
  })())())(couponsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(decodeCouponPromotion).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGetActivePromotionsResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetActivePromotionsResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(GetActivePromotionsResponseIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(/* #__PURE__ */ (() => {
      const decode2 = Data$dResult.decodeResult(decodeGetActivePromotionsError)(decodeGetActivePromotionsResponseContent).decode;
      return {decodeWithOptions: v => decode2};
    })()),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $GetActivePromotionsError,
  CouponPromotion,
  CouponPromotionIsSymbol,
  GetActivePromotionsRequest,
  GetActivePromotionsRequestIsSymbol,
  GetActivePromotionsResponse,
  GetActivePromotionsResponseContent,
  GetActivePromotionsResponseContentIsSymbol,
  GetActivePromotionsResponseIsSymbol,
  InvalidCoupon,
  InvalidCouponIsSymbol,
  boundedEnumGetActivePromo,
  boundedGetActivePromotion,
  codeIsSymbol,
  couponCodesIsSymbol,
  couponsIsSymbol,
  decodeCouponPromotion,
  decodeGetActivePromotionsError,
  decodeGetActivePromotionsRequest,
  decodeGetActivePromotionsResponse,
  decodeGetActivePromotionsResponseContent,
  encodeCouponPromotion,
  encodeGetActivePromotionsError,
  encodeGetActivePromotionsRequest,
  encodeGetActivePromotionsResponse,
  encodeGetActivePromotionsResponseContent,
  enumGetActivePromotionsEr,
  eq,
  eq5,
  eq6,
  eq7,
  eqCouponPromotion,
  eqGetActivePromotionsErro,
  eqGetActivePromotionsRequ,
  eqGetActivePromotionsResp,
  eqGetActivePromotionsResp1,
  genericBoundedEnumConstructor,
  genericCouponPromotion,
  genericEnumConstructor,
  genericGetActivePromotionsError,
  genericGetActivePromotionsRequest,
  genericGetActivePromotionsResponse,
  genericGetActivePromotionsResponseContent,
  hasFieldCouponPromotion,
  hasFieldGetActivePromotio,
  hasFieldGetActivePromotio1,
  newtypeCouponPromotion_,
  newtypeGetActivePromotion,
  newtypeGetActivePromotion1,
  newtypeGetActivePromotion2,
  ordGetActivePromotionsErr,
  promotionIdIsSymbol,
  promotionsIsSymbol,
  rPCMethodNameGetActivePro,
  rPCSitesGetActivePromotio,
  restaurantIdIsSymbol,
  showCouponPromotion,
  showGetActivePromotionsError,
  showGetActivePromotionsRequest,
  showGetActivePromotionsResponse,
  showGetActivePromotionsResponseContent,
  sourceIsSymbol,
  toFillFormTypeCouponPromo,
  toFillFormTypeGetActivePr,
  toFillFormTypeGetActivePr1,
  toFillFormTypeGetActivePr2,
  toFillFormTypeGetActivePr3,
  unscrambleDecodeCouponPromotion,
  unscrambleDecodeGetActivePromotionsError,
  unscrambleDecodeGetActivePromotionsRequest,
  unscrambleDecodeGetActivePromotionsResponse,
  unscrambleDecodeGetActivePromotionsResponseContent
};
